import React, { ComponentProps } from "react"

import Link from "~/components/atoms/Link"
import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import ActionBarWithOverview from "~/components/molecules/ActionBarWithOverview"
import Carousel from "~/components/molecules/Carousel"
import Tab from "~/components/molecules/Tab"
import User from "~/components/molecules/User"
import NewGradJobHead from "~/components/organisms/NewGradJobHead"
import ObservedActionBar from "~/observers/ActionBar"
import ObservedFavoriteButton from "~/observers/FavoriteButton"
import NewGradJob from "~/pages/next/new-grad-jobs/rich/[new-grad-job-id]"
import { internalLink } from "~/services/helper"

import CareerPath from "../_Common/_CareerPath"
import Company from "../_Common/_Company"
import Job from "../_Common/_Job"
import Requirements from "../_Common/_Requirements"
import * as styled from "../styled"

export const NewGradJobPage = ({ newGradJob }: ComponentProps<typeof NewGradJob>) => {
  return (
    <>
      <styled.Container>
        <NewGradJobHead
          occupation={newGradJob.minor_occupation.name}
          targetGradYears={newGradJob.target_grad_years}
          title={newGradJob.title}
          regions={newGradJob.regions}
          income={newGradJob.assumed_annual_income}
        />
        <div className="company-favorite-container">
          <Link
            href={internalLink("/companies/[company-id]")}
            dynamicRoutePath={internalLink(`/companies/${newGradJob.company.id}`)}
          >
            <User iconPath={newGradJob.company.main_img_url} name={newGradJob.company.name} type="Small" />
          </Link>
          {/* <ObservedFavoriteButton id={newGradJob.id} size="Medium" /> */}
        </div>
        <Carousel className="carousel">
          {newGradJob.images &&
            newGradJob.images.map((image, index) => {
              return (
                <img
                  key={index}
                  className="carousel-each-image"
                  src={image.img_url}
                  alt={`${newGradJob.title}のカバー画像${index}`}
                />
              )
            })}
        </Carousel>
        <Tab
          className="tab"
          size="Small"
          items={[{ name: "シゴト内容" }, { name: "キャリアパス" }, { name: "募集要項" }, { name: "会社概要" }]}
          selectedTabIndex={1}
          contents={[
            <Job job={newGradJob} />,
            <CareerPath job={newGradJob} />,
            <Requirements job={newGradJob} />,
            <Company company={newGradJob.company} showMore />,
          ]}
          full
        />
      </styled.Container>
      <Pc>
        <styled.ActionBarWrapper>
          <ActionBarWithOverview
            job={newGradJob.minor_occupation.name}
            title={newGradJob.title}
            companyName={newGradJob.company.name}
            type="newGradJob"
            id={newGradJob.id}
            status={newGradJob.public ? "public" : "private"}
            applicationUrl={newGradJob.needs_external_entry ? newGradJob.entry_url : undefined}
            curated={false}
          />
        </styled.ActionBarWrapper>
      </Pc>
      <Sp>
        <styled.ActionBarWrapper>
          <ObservedActionBar
            type="newGradJob"
            id={newGradJob.id}
            status={newGradJob.public ? "public" : "private"}
            applicationUrl={newGradJob.needs_external_entry ? newGradJob.entry_url : undefined}
            curated={false}
          />
        </styled.ActionBarWrapper>
      </Sp>
    </>
  )
}
